import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { EventAuthCard } from '@/components/eventos/EventAuthCard';

const API = process.env.REACT_APP_BACKEND_URL;

/** Link público (WhatsApp) para a família responder à autorização do evento. */
export default function AutorizacaoEventoPublica() {
  const { token } = useParams();
  const [c, setC] = useState(null);
  const [err, setErr] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    fetch(`${API}/api/public/eventos/autorizacao/${token}`).then(async (r) => { const j = await r.json(); if (!r.ok) throw new Error(j.detail); setC(j); })
      .catch((e) => setErr(e.message || 'Link inválido.'));
  }, [token]);
  const answer = async (resposta) => {
    setBusy(true);
    try {
      const r = await fetch(`${API}/api/public/eventos/autorizacao/${token}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ resposta }) });
      const j = await r.json(); if (!r.ok) throw new Error(j.detail);
      setC((x) => ({ ...x, autorizacao: j.autorizacao, resposta: j })); toast.success('Resposta registrada. Obrigado!');
    } catch (e) { toast.error(e.message || 'Falha ao responder.'); } finally { setBusy(false); }
  };
  return (
    <div className="min-h-screen bg-[#FBF9FD] px-4 py-10" data-testid="autz-publica">
      <div className="mx-auto max-w-md">
        <p className="mb-4 text-center text-[11px] font-bold uppercase tracking-[0.3em] text-[#7B3F98]">NOVO DNA · Eventos</p>
        {err ? <p className="rounded-2xl bg-white p-6 text-center text-sm text-[#D6336C]" data-testid="autz-erro">{err}</p>
          : !c ? <p className="flex items-center justify-center gap-2 py-10 text-sm text-[#6B5E7B]"><Loader2 className="h-4 w-4 animate-spin" /> Carregando…</p>
            : <EventAuthCard c={c} onAnswer={answer} busy={busy} />}
      </div>
    </div>
  );
}
